import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const UserFilledIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M12 3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM8 13.25A3.75 3.75 0 004.25 17v1.188c0 .754.546 1.396 1.29 1.517 4.278.699 8.642.699 12.92 0a1.537 1.537 0 001.29-1.517V17A3.75 3.75 0 0016 13.25h-.34c-.185 0-.369.03-.544.086l-.866.283a7.251 7.251 0 01-4.5 0l-.866-.283a1.752 1.752 0 00-.543-.086H8z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default UserFilledIcon;
